import Player from '@vimeo/player';

function initVideoShelf(shelf) {

    if (shelf.dataset.initialized === 'true') {
        return;
    }

    const iframe = shelf.querySelector(
        '[data-video-shelf-player]'
    );

    /*
     * Both desktop and mobile play controls.
     */
    const playButtons = shelf.querySelectorAll(
         '[data-video-shelf-play]'
    );

    const pauseButton = shelf.querySelector(
        '[data-video-shelf-pause]'
    );

    /*
     * We need a player and at least one play control.
     */
    if (!iframe || !playButtons.length) {
        return;
    }

    shelf.dataset.initialized = 'true';

    const player = new Player(iframe);

    let overlayTimer = null;


    function clearOverlayTimer() {

        if (!overlayTimer) {
            return;
        }

        window.clearTimeout(overlayTimer);
        overlayTimer = null;

    }


    function hideOverlay() {

        clearOverlayTimer();

        shelf.classList.add('is-playing');

    }


    function showOverlay() {

        clearOverlayTimer();

        shelf.classList.remove('is-playing');

    }


    function delayedOverlay() {

        clearOverlayTimer();

        overlayTimer = window.setTimeout(
            showOverlay,
            2000
        );

    }


    /*
     * Shared play behaviour.
     *
     * Desktop text button and mobile overlay button
     * both control the same Vimeo player.
     */
    function playVideo() {

        hideOverlay();

        player.play().catch(() => {
            showOverlay();
        });

    }


    /*
     * Attach play behaviour to every play control.
     */
    playButtons.forEach((button) => {

        button.addEventListener(
            'click',
            playVideo
        );

    });


    /*
     * Pause control.
     */
    if (pauseButton) {

        pauseButton.addEventListener('click', () => {

            player.pause();

        });

    }


    /*
     * Keep shelf state synchronised with Vimeo.
     */
    player.on('play', () => {

        hideOverlay();

    });


    player.on('pause', () => {

        delayedOverlay();

    });


    player.on('ended', () => {

        showOverlay();

    });

}


function initVideoShelves(scope = document) {

    scope
        .querySelectorAll('[data-video-shelf]')
        .forEach(initVideoShelf);

}


if (document.readyState === 'loading') {

    document.addEventListener(
        'DOMContentLoaded',
        () => initVideoShelves()
    );

} else {

    initVideoShelves();

}


/*
 * ACF Gutenberg preview.
 */
if (window.acf) {

    window.acf.addAction(
        'render_block_preview/type=filtronic/video-shelf',
        ($block) => {

            $block
                .find('[data-video-shelf]')
                .each(function () {
                    initVideoShelf(this);
                });

        }
    );

}